var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelBarbijoNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.36 19.17C11.6468 19.17 12.69 18.1268 12.69 16.84C12.69 15.5532 11.6468 14.51 10.36 14.51C9.07318 14.51 8.03 15.5532 8.03 16.84C8.03 18.1268 9.07318 19.17 10.36 19.17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.64 19.17C22.9268 19.17 23.97 18.1268 23.97 16.84C23.97 15.5532 22.9268 14.51 21.64 14.51C20.3532 14.51 19.31 15.5532 19.31 16.84C19.31 18.1268 20.3532 19.17 21.64 19.17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 13.44C22.3 9.96062 19.4794 7.14001 16 7.14001C12.5206 7.14001 9.7 9.96062 9.7 13.44V19.14C9.7 22.6194 12.5206 25.44 16 25.44C19.4794 25.44 22.3 22.6194 22.3 19.14V13.44Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.69C10.48 5.69 6.9 10.36 9.69 16.52C9.69 16.52 9.59 10.07 12.11 10.07C12.11 10.07 12.71 10.77 16 10.77C19.29 10.77 19.89 10.07 19.89 10.07C22.41 10.07 22.31 16.52 22.31 16.52C25.1 10.36 21.52 5.69 16 5.69Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 10.07C14.56 11.4 17.67 12.37 16.51 11.18C16.4908 11.1611 16.4786 11.1363 16.4752 11.1096C16.4718 11.0829 16.4775 11.0559 16.4914 11.0328C16.5052 11.0097 16.5264 10.992 16.5515 10.9824C16.5767 10.9728 16.6043 10.972 16.63 10.98C18.72 11.67 25.01 13.6 19.89 10.07",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 10.07C14.56 11.4 17.67 12.37 16.51 11.18C16.4908 11.1611 16.4786 11.1363 16.4752 11.1096C16.4718 11.0829 16.4775 11.0559 16.4914 11.0328C16.5052 11.0097 16.5264 10.992 16.5515 10.9824C16.5767 10.9728 16.6043 10.972 16.63 10.98C18.72 11.67 25.01 13.6 19.89 10.07",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelBarbijoNo);
export default __webpack_public_path__ + "static/media/SelBarbijoNO.1162548f21004747461f14e6e00f0807.svg";
export { ForwardRef as ReactComponent };